/* eslint-disable no-case-declarations */
/* eslint-disable no-unused-vars */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { addDoc, collection, deleteDoc, doc, getDocs, onSnapshot, setDoc } from 'firebase/firestore'
import { firestore, auth } from '../../config/firebase'

let expensesUnsubscribe = null;
let expensesSubscribed = false;

export const startExpensesListener = createAsyncThunk(
  'expenses/startListener',
  async (_, { dispatch }) => {
    if (expensesSubscribed) return;
    expensesSubscribed = true;

    const ref = collection(firestore, 'expenses');
    expensesUnsubscribe = onSnapshot(ref, (snapshot) => {
      const expensesData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));
      
      // Sort by createdAt descending (newest first)
      const sortedExpenses = expensesData.sort((a, b) => 
        new Date(b.createdAt || 0) - new Date(a.createdAt || 0)
      );
      
      console.log(`💸 Expenses loaded: ${sortedExpenses.length} items`)
      dispatch(setExpenses(sortedExpenses));
    });
  }
);

export const stopExpensesListener = createAsyncThunk(
  'expenses/stopListener',
  async () => {
    if (expensesUnsubscribe) expensesUnsubscribe();
    expensesUnsubscribe = null;
    expensesSubscribed = false;
  }
);

// Keep the old function name for backward compatibility
export const getAllExpenditures = startExpensesListener;

export const addNewExpenditure = createAsyncThunk('auth/addNewExpenditure', async (data) => {
  const { close, ...rest } = data
  try {
    const ExpenditureCollection = collection(firestore, 'expenses')
    const optimisticData = {
      ...rest,
      creator: auth.currentUser.uid,
      createdAt: rest.createdAt || new Date().toISOString() // Ensure timestamp is included
    }
    await addDoc(ExpenditureCollection, optimisticData)
    return optimisticData
  } catch (error) {
    console.log(error)
    throw new Error(error.message) // Handle any errors
  } finally {
    close && close()
  }
})

export const updateExpenditure = createAsyncThunk('auth/updateExpenditure', async (data) => {
  const { close, id, ...rest } = data
  try {
    const ExpenditureRef = doc(firestore, 'expenses', id)
    const optimisticData = {
      ...rest
    }
    await setDoc(ExpenditureRef, optimisticData, { merge: true })
    return optimisticData
  } catch (error) {
    console.log(error)
    throw new Error(error.message) // Handle any errors
  } finally {
    close && close()
  }
})

export const deleteExpenditure = createAsyncThunk('auth/deleteExpenditure', async (data) => {
  const { close, id } = data
  try {
    const ExpenditureRef = doc(firestore, 'expenses', id)
    await deleteDoc(ExpenditureRef)
    return id
  } catch (error) {
    console.log(error)
    throw new Error(error.message) // Handle any errors
  } finally {
    close && close()
  }
})

const expenses = createSlice({
  name: 'expenses',
  initialState: {
    expenses: [],
    loading: false,
    error: null
  },
  reducers: {
    setExpenses: (state, action) => {
      state.expenses = action.payload;
      state.loading = false;
    },
    resetExpenses: (state) => {
      expensesSubscribed = false;
      state.expenses = [];
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(startExpensesListener.pending, (state) => {
        state.loading = true
      })
      .addCase(startExpensesListener.fulfilled, (state, action) => {
        state.loading = false
        state.error = null
      })
      .addCase(startExpensesListener.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })
  }
})

export const { setExpenses, resetExpenses } = expenses.actions
export default expenses.reducer
